import "@/../css/confetti.css";
import { confetti, ConfettiOptions } from "@tsparticles/confetti";

export default function playConfetti(props?: ConfettiOptions) {
    const end = Date.now() + 0.5 * 1000;
    (function frame() {
        confetti({
            particleCount: 2,
            angle: 60,
            spread: 55,
            origin: { x: 0 },
            ...props,
        });

        confetti({
            particleCount: 2,
            angle: 120,
            spread: 55,
            origin: { x: 1 },
            ...props,
        });

        if (Date.now() < end) {
            requestAnimationFrame(frame);
        }
    })();
}
